<template>
    <div>
        <dx-grid url="documents" :columns="columns" :title="title"></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "Documents",
        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                icon: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "UPLOADED":
                            return "mdi-file-upload";
                        case "PENDING REVIEW":
                            return "mdi-flag-outline";
                        case "REJECTED":
                            return "mdi-close-circle";
                        case "SENT TO VAAD MISHMERES":
                        case "SENT TO VAAD-MISHMERES":
                            return "mdi-email";
                        case "IMPORTED":
                        case "IMPORTED-SD":
                        case "COMPLETED":
                            return "mdi-file-check";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    if (!value) return "";

                    switch (value.trim()) {
                        case "UPLOADED":
                            return "#aeb8bf";
                        case "PENDING REVIEW":
                            return "#fdb400";
                        case "REJECTED":
                            return "#f35123";
                        case "SENT TO VAAD MISHMERES":
                            return "info";
                        case "IMPORTED":
                        case "IMPORTED-SD":
                        case "COMPLETED":
                            return "success";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Hebrew Name",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "dateUploaded",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(1, "month")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
                visible: true,
            },
            {
                label: "Type",
                field: "docTypeID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "File Name",
                field: "fileURL",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                    //return row.status == "UPLOADED";
                },
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status Info",
                field: "statusInfo",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Home Phone",
                field: "homePhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Cell Phone",
                field: "cellPhone",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "emailAddress",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {
        this.columns.find((c) => c.field == "fileURL").linkAction = (
            document,
        ) => {
            const url =
                getDomain() +
                "/api/Documents/DownloadDocument?uploadID=" +
                document.uploadID;

            window.open(url);
        };
    },
    methods: {
        mapDocument(document) {
            if (document.status != "UPLOADED") {
                document.fileURL = "";
            }

            return document;
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
</style>
